import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PackingBoxCreateLabelService } from 'src/app/views/packing-box/dialog/create-label/create-label.service';
import { CompoundingPackingBoxCreateLabelType } from './simple-batch.component';
import { PackingBoxCreateLabelType } from 'src/app/views/packing-box/types/create-label-dialog';
import { Batch } from '../../../../api/elite/types/batch';

@Injectable()
export class CompoundingSimpleLabelService extends PackingBoxCreateLabelService {
  private _filteredBatches: Batch[] = [];
  get filteredBatches(): Batch[] {
    return this._filteredBatches;
  }

  formBatches = new FormGroup({
    workOrderBatch: new FormControl<number>(undefined),
    search: new FormControl<string>(undefined),
  });

  setBatchesToRequired(): void {
    this.formBatches.get('workOrderBatch').setValidators([Validators.required]);
    this.formBatches.get('workOrderBatch').updateValueAndValidity();
  }

  override onSave(
    data: CompoundingPackingBoxCreateLabelType['data']
  ):
    | CompoundingPackingBoxCreateLabelType['response']
    | PackingBoxCreateLabelType['response'] {
    const batches = Array.isArray(data.batches) ? data.batches : [data.batches];
    data.department = 'Compouding';
    const res = super.onSave(data);
    if (batches.length > 0 && this.formBatches.invalid) {
      this.alertService.error('Necesitas seleccionar un batch');
      return undefined;
    }
    if (batches.length === 0) {
      return res;
    }
    const woBatch = batches.find(
      (b) => b.id === this.formBatches.get('workOrderBatch').value
    );

    return {
      ...res,
      workOrderBatchId: this.formBatches.get('workOrderBatch').value,
      batch: ` ${woBatch.batchNumber}`,
    };
  }

  selectingBatches(batches: Batch[]): void {
    this.setBatchesToRequired();
    this._filteredBatches = batches;
    const quantityCtrl = this.form.get('quantity');
    quantityCtrl.disable({ emitEvent: false });
    quantityCtrl.clearValidators();
    const numLabelController = this.form.get('numLabels');
    numLabelController.disable({ emitEvent: false });
    this.formBatches
      .get('workOrderBatch')
      .valueChanges.subscribe((batchId: number) => {
        if (!batchId) {
          return;
        }

        const batch = batches.find((b) => b.id === batchId);
        if (!batch) {
          return;
        }

        quantityCtrl.clearValidators();
        quantityCtrl.setValue(batch.quantity, { emitEvent: false });
        quantityCtrl.disable({ emitEvent: false });
        quantityCtrl.updateValueAndValidity();
      });

    this.formBatches.get('search').valueChanges.subscribe((value = null) => {
      if (!value) {
        this._filteredBatches = batches;
      } else {
        this._filteredBatches = batches.filter((val) =>
          `${val.batchNumber}`.toUpperCase().includes(value.toUpperCase())
        );
      }
    });
  }

  automaticBatchSelection(batches: Batch & { maxQuantity: number }): void {
    this._filteredBatches = [batches];
    this.setBatchesToRequired();
    this.formBatches.get('workOrderBatch').setValue(batches.id);
    this.formBatches.get('workOrderBatch').disable({ emitEvent: false });
  }
}
